module.exports = __webpack_public_path__ + "img/tmf2026_speech.ca92913d.jpg";